import { HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, Component, ViewChild } from "@angular/core";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { ChapterMenu } from "../models/interfaces/chapter.model";
import { MenuController, Nav, NavController, Platform } from "ionic-angular";
import { AlertController, App, IonicApp, IonicModule, ToastController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Router } from '@angular/router';

import { Member } from "../models/interfaces/member.model";
import { CommitteePage } from "../pages/committee/committee";
import { ExpensesPage } from "../pages/expenses/expenses";
import { HarelinePage } from "../pages/hareline/hareline";
import { HomePage } from "../pages/home/home";
import { LoginPage } from "../pages/login/login";
import { MemberPage } from "../pages/member/member";
import { OnhomePage } from "../pages/onhome/onhome";
import { PaymentPage } from "../pages/payment/payment";
import { PledgePage } from "../pages/pledge/pledge";
import { RunCountPage } from "../pages/runcount/runcount";
import { SettingsPage } from "../pages/settings/settings";
import { Sh3Page } from "../pages/sh3/sh3";
import { DashPage } from "../pages/dash/dash";
import { SongsPage } from "../pages/songs/songs";
import { TrackingPage } from "../pages/tracking/tracking";
import { UploadPage } from "../pages/upload/upload";
import { AuthService } from "../providers/dbservice/authservice";
import { ConfigService } from "../providers/dbservice/configservice";
import { DbserviceProvider } from "../providers/dbservice/dbservice";

export function initConfig(config: ConfigService) {
  return () => config.load();
}

@Component({
  templateUrl: "app.html",
})

export class SH3 {
  @ViewChild(Nav) nav: Nav;

  private chapterMenu: ChapterMenu[] = [];

  // rootPage: any = CommitteePage;
  // rootPage: any = ExpensesPage;
  private rootPage: any = HomePage;
  // rootPage: any = RegisterPage;
  // rootPage: any = PledgeAddPage;
  // rootPage: any = HomePage;
  // rootPage: any = HarelinePage;
  // rootPage: any = MemberPage;
  // rootPage: any = PaymentPage;
  // rootPage: any=LoginPage;
  // rootPage: any = ListComponent;

  // https://angular.io/guide/http


  private pages = [];
  private currentUser: Observable<Member>;

  public appTitle: string = "";
  private styleName: string ="";

  constructor(
    public authService: AuthService, statusBar: StatusBar, splashScreen: SplashScreen,
    public platform: Platform, private app: App, public alertCtrl: AlertController,
    public menu: MenuController, private db: DbserviceProvider, private configService: ConfigService,
    private http: HttpClientModule, private toastCtrl: ToastController,
    private _app: App, private _ionicApp: IonicApp, private _menu: MenuController,private router: Router,
  ) {
    console.log("app.components constructor");
    

    this.pages = [];
    this.appTitle=this.configService.getConfig("APPLICATION");
    this.styleName=this.configService.getConfig("STYLENAME");

    this.db.dbCol({
      "action": "select", "mapObject": "chapter_menu", "sqlExtended": " where 1=1 and chapter.cp_default_flg='1' and chapter_menu.cm_is_active='true' order by cm_order",
    })
      .subscribe((data: any) => {
        this.appTitle = data[0].cp_short_name;
        this.pages = data;
      },
        (error) => { console.error("error", error); },
      );

    this.setupBackButtonBehavior();

  }

  private filter(pageList) {
    console.log("app.component filter");
    if (!this.authService.isLoggedIn) {
      return pageList.filter(page => String(page.cm_is_public) === String('true'));
    }
    else {
      let hasPaymentAccess = this.db.hasAccess(PaymentPage.PAYMENT_PY_VIEW_ACCESS);
      let hasPledgeAccess = this.db.hasAccess(PledgePage.PLEDGE_VIEW_ACCESS);
      let hasMemberAccess = this.db.hasAccess(MemberPage.MEMBER_VIEW_ACCESS);
      let hasSettingsAccess = this.db.hasAccess(SettingsPage.SETTINGS_VIEW_ACCESS);
      let hasSongsAccess = this.db.hasAccess(SongsPage.SONGS_VIEW_ACCESS);
      let hasLogoutAccess = true;

      return pageList.filter((page) => (String(page.cm_is_public) === String(true)
        || (hasLogoutAccess && String(page.cm_component) === String('LoginPage'))
        || (hasPaymentAccess && String(page.cm_component) === String('PaymentPage'))
        || (hasPledgeAccess && String(page.cm_component) === String('PledgePage'))
        || (hasMemberAccess && String(page.cm_component) === String('MemberPage'))
        || (hasMemberAccess && String(page.cm_component) === String('RunCountPage'))
        || (hasSettingsAccess && String(page.cm_component) === String('SettingsPage'))
        || (hasSongsAccess && String(page.cm_component) === String('SongsPage'))
      ));
    }

  }

  private setupBackButtonBehavior() {

    if (window.location.protocol !== "file:") {
      window.onpopstate = (evt) => {
        this.nav.pop({});
      };

      // Fake browser history on each view enter
      this._app.viewDidEnter.subscribe((app) => {
        history.pushState(null, null, "");
      });
    }

  }

  private openPage(page) {
    this.menu.close();
    console.log("AppComponents openPage");
    
    if (page.cm_title === "Logout") {
      this.logout();
    }
    else {
      if ( String(page.cm_component) === String('LoginPage') ) {this.nav.push(LoginPage)};
      if ( String(page.cm_component) === String('HomePage') ) {this.nav.push(HomePage)};
      if ( String(page.cm_component) === String('HarelinePage') ) {this.nav.push(HarelinePage)};
      if ( String(page.cm_component) === String('MemberPage') ) {this.nav.push(MemberPage)};
      if ( String(page.cm_component) === String('RunCountPage') ) {this.nav.push(RunCountPage)};
      if ( String(page.cm_component) === String('PaymentPage') ) {this.nav.push(PaymentPage)};
      if ( String(page.cm_component) === String('PledgePage') ) {this.nav.push(PledgePage)};
      if ( String(page.cm_component) === String('SongsPage') ) {this.nav.push(SongsPage)};
      if ( String(page.cm_component) === String('CommitteePage') ) {this.nav.push(CommitteePage)};
      if ( String(page.cm_component) === String('Sh3Page') ) {this.nav.push(Sh3Page)};
      if ( String(page.cm_component) === String('DashPage') ) {this.nav.push(DashPage)};
      if ( String(page.cm_component) === String('UploadPage') ) {this.nav.push(UploadPage)};
      if ( String(page.cm_component) === String('OnhomePage') ) {this.nav.push(OnhomePage)};
      if ( String(page.cm_component) === String('SettingsPage') ) {this.nav.push(SettingsPage)};

      //this.core.navToPage(link.linkHref);
      //this.nav.push(page.cm_component);
      //this.router.navigate(['pages/member']);
      //this.nav.push(eval('MemberPage'));
    }
  }

  private logout() {
    //this.nav.push("LoginPage");
    console.log("AppComponents doLogout");

    this.authService.doLogout();
    // this.authService.privs = undefined;
    this.nav.push(HomePage);

    // this.authService.doLogout();
    // this.menu.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts